import styled from 'styled-components';

export const FilterBox = styled.div`
	display: flex;
	gap: 0 20px;
	margin-bottom: 12px;
`;
export const FormField = styled.div<{ $borderLess?: boolean }>`
	display: flex;
	padding: 32px 0;
	border-bottom: ${({ theme, $borderLess }) =>
		$borderLess ? 'none' : `1px solid ${theme.colors.ultraLightGrayBorder}`};
`;
export const FieldLabel = styled.div`
	width: 164px;
`;
export const FieldSection = styled.div<{ $maxWidth?: string }>`
	max-width: ${({ $maxWidth }) => ($maxWidth ? $maxWidth : '630px')};
	flex: 1;
	position: relative;
`;
export const FlexBox = styled.div<{ $gap?: string; $margin?: string; $alignItems?: string; $justifyContent?: string }>`
	display: flex;
	align-items: ${({ $alignItems }) => ($alignItems ? $alignItems : 'flex-end')};
	justify-content: ${({ $justifyContent }) => ($justifyContent ? $justifyContent : 'flex-start')};
	gap: ${({ $gap }) => ($gap ? $gap : '0 20px')};
	margin: ${({ $margin }) => ($margin ? $margin : '0 0 24px')};
`;
export const FieldTitle = styled.div<{ $margin?: string }>`
	${({ theme }) => theme.typography.body2}
	margin: ${({ $margin }) => ($margin ? $margin : '20px 0')};
`;
export const FieldValue = styled.div<{ $margin?: string }>`
	${({ theme }) => theme.typography.body2}
	margin: ${({ $margin }) => ($margin ? $margin : '0 0 20px')};
`;
export const OptionalFiled = styled.div<{ $isLast?: boolean }>`
	position: relative;
	padding-bottom: 24px;
	margin-bottom: ${({ $isLast }) => ($isLast ? 0 : 24)}px;
	border-bottom: ${({ theme, $isLast }) => ($isLast ? 'none' : `1px solid ${theme.colors.blackColor}`)};
`;
export const DeleteOptionButton = styled.div`
	width: 20px;
	height: 20px;
	position: absolute;
	top: -10px;
	right: -15px;
`;
export const GridBox = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 28px 60px;
`;
